import { render } from "./DepartmentServices.vue?vue&type=template&id=d70f46ae&scoped=true"
import script from "./DepartmentServices.vue?vue&type=script&lang=js"
export * from "./DepartmentServices.vue?vue&type=script&lang=js"

import "./DepartmentServices.vue?vue&type=style&index=0&id=d70f46ae&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d70f46ae"]])

export default __exports__